export default "__VITE_ASSET__Dd3_MeGs__"